export default {"src":"/_next/static/media/github.198c4036.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};